import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const BrandDiscoverPage = lazy(
  () =>
    import('./BrandDiscoverPage.eager').then(mod => ({
      default: mod.BrandDiscoverPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
